import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  Stack,
  StackDivider,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Card from '../components/Card';
import logo from '../assets/image/logo.png';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { securedAxiosInstance } from '../api/axios';

const InviteAccept = () => {
  const [params] = useSearchParams();
  const schema = yup
    .object({
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      password: yup
        .string()
        .min(8, 'Must be at least 8 characters long')
        .required('Password is required'),
      confirmPassword: yup
        .string()
        .required('Please retype your password.')
        .oneOf([yup.ref('password')], 'Your passwords do not match.'),
    })
    .required();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const toast = useToast();
  const onSubmit = async data => {
    try {
      const res = await securedAxiosInstance.post(`/update_invited_user`, {
        user: {
          first_name: data.firstName,
          last_name: data.lastName,
          password: data.password,
          password_confirmation: data.confirmPassword,
          invitation_token: params.get('invitation_token'),
        },
      });
      if (res.data.status !== 'Invitation Accepted!') {
        toast({
          title: 'Something went wrong',
          description:
            'Please try again later, or check the invitation code is correct.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'bottom-right',
        });
      } else {
        toast({
          description: 'Your Profile has been Updated!',
          colorScheme: 'primary',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
          variant: 'primary',
        });
        navigate('/');
      }
    } catch (error) {
      toast({
        title: 'Something went wrong',
        description:
          'Please try again later, or check the invitation code is correct.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    }

    // if (!res.data) {
    //   return navigate('/shared_journal/404');
    // }
  };

  return (
    <Stack spacing={8} mx={'auto'} maxW={'6xl'} w={'100%'} py={12} px={6}>
      <Card>
        <Stack
          spacing={4}
          direction={{ base: 'column', md: 'row' }}
          justify={'space-between'}
          align={'center'}
          divider={<StackDivider borderColor="gray.200" />}
        >
          <Box p={8}>
            <Image
              src={logo}
              alt="4 boxes logo"
              boxSize="300px"
              objectFit="contain"
            />
          </Box>
          <Box p={8} w={'100%'} maxW={'2xl'} mx="auto">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack>
                <Stack
                  spacing={4}
                  direction={{ base: 'column', md: 'row' }}
                  justify={'space-between'}
                  align={'flex-start'}
                >
                  <FormControl id="firstName" isInvalid={errors.firstName}>
                    <FormLabel htmlFor="firstName">First Name</FormLabel>
                    <Input id="firstName" {...register('firstName')} />
                    <FormErrorMessage>
                      {errors.firstName && errors.firstName.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl id="lastName" isInvalid={errors.lastName}>
                    <FormLabel htmlFor="lastName">Last Name</FormLabel>
                    <Input id="lastName" {...register('lastName')} />
                    <FormErrorMessage>
                      {errors.lastName && errors.lastName.message}
                    </FormErrorMessage>
                  </FormControl>
                </Stack>
                <Stack
                  spacing={4}
                  direction={{ base: 'column', md: 'row' }}
                  justify={'space-between'}
                  align={'flex-start'}
                >
                  <FormControl id="password" isInvalid={errors.password}>
                    <FormLabel htmlFor="password">Password</FormLabel>
                    <Input
                      type="password"
                      id="password"
                      {...register('password')}
                    />
                    <FormErrorMessage>
                      {errors.password && errors.password.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    id="confirmPassword"
                    isInvalid={errors.confirmPassword}
                  >
                    <FormLabel htmlFor="confirmPassword">
                      Password Confirmation
                    </FormLabel>
                    <Input
                      type="password"
                      id="confirmPassword"
                      {...register('confirmPassword')}
                    />
                    <FormErrorMessage>
                      {errors.confirmPassword && errors.confirmPassword.message}
                    </FormErrorMessage>
                  </FormControl>
                </Stack>
                <Stack spacing={4}>
                  <Button isLoading={isSubmitting} type="submit">
                    Submit
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Stack>
      </Card>
    </Stack>
  );
};

export default InviteAccept;
